import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReporteSalidas } from "../redux/actions";
import Swal from "sweetalert2";
import axios from "axios";

// Función reutilizable para generar remitos
const generarRemito = async (salida) => {
  try {
    const { id, productos, cliente, autorizado, usuario, obra } = salida;

    const response = await axios.post(
      "/api/remitoRepSalidas",
      {
        id,
        productos: productos.map((producto) => ({
          idProducto: producto.idProducto,
          cantidad: producto.cantidad,
          nombreProducto: producto.nombreProducto,
          unidadMedida: producto.unidadMedida,
        })),
        cliente,
        autorizado,
        usuario,
        obra,
        fecha: new Date().toISOString(),
      },
      { responseType: "blob" } // Importante para manejar archivos binarios
    );

    // Crear un enlace para descargar el archivo
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `remito_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    Swal.fire({
      title: "Remito Generado",
      text: `El remito para el cliente ${cliente} ha sido generado exitosamente.`,
      icon: "success",
      confirmButtonText: "Cerrar",
    });
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Hubo un problema al generar el remito.",
      icon: "error",
      confirmButtonText: "Cerrar",
    });
  }
};


const ReporteSalidas = () => {
  const dispatch = useDispatch();
  const reporteSalidas = useSelector((state) => state.reporteSalidas);
  

  useEffect(() => {
    dispatch(getReporteSalidas());
  }, [dispatch]);

  return (
    <div className="p-8 bg-backgroundClaro min-h-screen">
      <h2 className="text-4xl font-bold text-textoOscuro mb-4">Reporte de Salidas</h2>
      

      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-400">
          <thead>
            <tr>
              <th className="border border-gray-400 text-textoOscuro p-2">Usuario</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Autorizado</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Fecha</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Cliente</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Productos</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Cantidad</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Unidad</th>
              <th className="border border-gray-400 text-textoOscuro p-2">Obra</th>
            </tr>
          </thead>
          <tbody>
            {reporteSalidas.length > 0 ? (
              reporteSalidas.map((salida) => (
                <tr key={salida.id}>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {salida.usuario}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {salida.autorizado}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {new Date(salida.fecha).toLocaleString()}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {salida.cliente}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {salida.productos.map((producto, index) => (
                      <div key={index}>
                        {producto.nombreProducto}
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {salida.productos.map((producto, index) => (
                      <div key={index}>
                        {producto.cantidad} unidades
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {salida.productos.map((producto, index) => (
                      <div key={index}>
                        {producto.unidadMedida}
                      </div>
                    ))}
                  </td>
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    {salida.obra}
                  </td>
                  {/* Botón para generar remito para una salida específica */}
                  <td className="border border-gray-400 text-textoOscuro p-2">
                    <button
                      onClick={() => generarRemito(salida)}
                      className="px-4 py-2 bg-blue-600 text-textoOscuro rounded-md hover:bg-blue-500"
                    >
                      Generar Remito
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="border border-gray-400 text-textoOscuro p-2" colSpan="8">
                  No hay salidas registradas
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReporteSalidas;
